<template>
	<div>
			<v-card>
				<v-card-title>Recordings</v-card-title>
				<v-card-text>
					<p v-if="!appointment.videoMeeting">No video appointment has taken place</p>
					<v-list v-else>
						<v-list-item v-for="(roomSid, i) in appointment.videoMeeting.roomSids" :key="roomSid">
							<v-list-item-content>
								<v-list-item-title >Video appointment <span v-if="i > 0" >{{i+1}}</span></v-list-item-title>
							</v-list-item-content>
							<v-list-item-icon>
								<v-dialog v-model="dialog" width="460px" v-if="!warning(roomSid)">
									<template v-slot:activator="{ on }">
										<v-btn color="green" dark v-on="on">Generate New Recording</v-btn>
									</template>
									<v-card>					
										<v-card-title>Are you sure?</v-card-title>		
										<v-card-text>
											<p>Recordings are the video and audio tracks from each participant in one single media file.
											These can take approximately 24 hours to be rendered.</p> 
											
										</v-card-text>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn v-if="!warning(roomSid)" @click="generateRecording(roomSid)" color="red" dark>
												Generate New Recording
											</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
								<div v-else>
									<div v-for="composition in videoCompositions.filter( v => v.roomSid == roomSid) " :key="composition.id">
									<p class="text-right mb-0"> 
										{{compositionStatus(composition.status)}}
									<v-tooltip bottom v-if="composition.status !== 'composition-available'">
										<template v-slot:activator="{ on }">
											<v-icon	v-on="on">mdi-help-circle</v-icon>
										</template>
										<span>Recordings can take approximately an hour to be rendered</span>
									</v-tooltip>
									<span v-else>
										
										<v-btn icon v-if="!downloading" @click="getCompositionDownload(composition)"><v-icon>mdi-download</v-icon></v-btn>
										<v-progress-circular v-else size="25" color="secondary" indeterminate></v-progress-circular>
									</span>
									</p>
									<v-progress-linear class="mt-2" v-if="composition.percentageComplete" color="green" v-model="composition.percentageComplete"></v-progress-linear>
										<p class="text-right mt-0"><span class="overline">{{ composition.created.toDate() | moment("dddd, MMMM Do YYYY, h:mm a") }}</span></p>
									</div>

								</div>
							</v-list-item-icon>
						</v-list-item>
					</v-list>
				</v-card-text>
			</v-card>
	</div>
</template>

<script>
	import axios from 'axios';

	// import FileSaver from "file-saver";
	import Vuex from "vuex"; 
	
	import {prettyPrint} from "../../../assets/utilities.js"
	export default {
		name: "Recordings", 
		data: () => {
			return {
				dialog: false,
				downloading: false
			}
		},
		props: {
			appointment: {type: Object}
		}, 
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user, 
				videoCompositions(state){
					var id = this.appointment.id;
					return state[state.auth.view].videoCompositions.filter( a => a.appointment == id );
				}
			}),
		},
		methods: {
			async getDownload(compositionSid, id) {
				return await axios.get(`https://x.m.works:1880/twilio/updateRecording/${compositionSid}/${id}`)
				// return await axios.get(`http://localhost:3000/token?identity=${identity}`);
			},
			getCompositionDownload(composition){
				event.preventDefault();
				const self = this;
				this.getDownload( composition.compositionSid, composition.id).then( ( ) => {
					location.href = composition.compositionLink;
					self.downloading = false;
				})
			},
			compositionStatus(status){
				if( status.substring(0,11) !== "composition"){
					status = "composition-" + status;
				}
				return prettyPrint(status, "TITLE")
			},
			warning(roomSid){
				const self = this;
				var recording = self.videoCompositions.find( a => a.roomSid == roomSid );
				if( !recording ){
					return false;
				}
				else{
					return true;
				}
			},
			generateRecording(roomSid){
				var self = this;
				var user = this.user.uid;
				var appointment = this.appointment.id;
				this.$store.dispatch( "addDoc", {
					collection: "videoCompositions", 
					data: {
						roomSid: roomSid, 
						user: user, 
						appointment: appointment,
						status: 'initiated'
					}
				}).then( () => {
					self.dialog = false;
				})
			} 
		}, 
		watch:{
			appointment: {
				immediate: true,
				handler(){
					this.$store.dispatch("fetchVideoCompositions", this.appointment.id )
				}
			}
		}
	}
</script>